/**
 * Site Notification Popup Script
 * 
 * Handles:
 * - Show notification on first page load
 * - Dismiss and remember in sessionStorage
 * - Re-open via persistent button
 * - Keyboard accessibility (Escape to close)
 * - Focus trapping within dialog
 */

(function() {
  'use strict';

  // Storage key for tracking dismissal
  const STORAGE_KEY = 'lcc-notification-dismissed';

  // DOM Elements
  const notification = document.querySelector('[data-notification]');
  const overlay = document.querySelector('[data-notification-overlay]');
  const dialog = document.querySelector('[data-notification-dialog]');
  const closeButtons = document.querySelectorAll('[data-notification-close]');
  const reopenButton = document.querySelector('[data-notification-reopen]');

  // Exit if notification doesn't exist
  if (!notification) return;

  /**
   * Open the notification dialog
   */
  function openNotification() {
    notification.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    
    // Hide persistent button
    if (reopenButton) {
      reopenButton.style.display = 'none';
      reopenButton.classList.remove('is-visible');
    }

    // Focus the dialog for accessibility
    setTimeout(() => {
      const firstFocusable = dialog.querySelector('button');
      if (firstFocusable) firstFocusable.focus();
    }, 100);
  }

  /**
   * Close the notification dialog
   */
  function closeNotification() {
    notification.classList.remove('is-open');
    document.body.style.overflow = '';
    
    // Mark as dismissed in session storage
    try {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {
      // sessionStorage not available
    }

    // Show persistent button
    if (reopenButton) {
      reopenButton.style.display = 'flex';
      setTimeout(() => {
        reopenButton.classList.add('is-visible');
      }, 10);
    }
  }

  /**
   * Check if notification was previously dismissed
   */
  function wasDismissed() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === 'true';
    } catch (e) {
      return false;
    }
  }

  /**
   * Handle keyboard events
   */
  function handleKeydown(e) {
    if (e.key === 'Escape' && notification.classList.contains('is-open')) {
      closeNotification();
    }
  }

  /**
   * Initialize event listeners
   */
  function init() {
    // Close button clicks
    closeButtons.forEach(button => {
      button.addEventListener('click', closeNotification);
    });

    // Overlay click to close
    if (overlay) {
      overlay.addEventListener('click', closeNotification);
    }

    // Reopen button click
    if (reopenButton) {
      reopenButton.addEventListener('click', openNotification);
    }

    // Escape key to close
    document.addEventListener('keydown', handleKeydown);

    // Initial state: show or hide based on session
    if (wasDismissed()) {
      // Already dismissed - show persistent button
      if (reopenButton) {
        reopenButton.style.display = 'flex';
        reopenButton.classList.add('is-visible');
      }
    } else {
      // First visit - show notification
      openNotification();
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
